import React from "react";
import {
  Train,
  Plane,
  Hotel,
  ShoppingBag,
  Coffee,
  Camera,
  Music,
  Star,
  Zap,
  Gamepad2,
  Wand2,
  Ticket,
  Utensils,
  Gift,
  Landmark,
  IceCream,
  Footprints,
  Store,
} from "lucide-react";

// Helper component for rendering icons consistently
const Icon = ({ component: Component }) => (
  <Component size={16} className="text-hojicha" />
);

export const itineraryData = [
  {
    day: 1,
    date: "1/21 (三)",
    title: "抵達大阪 & 梅田逛街",
    events: [
      {
        time: "07:35",
        title: "機場捷運（環北→一航）",
        icon: <Icon component={Train} />,
        note: "08:06 抵達",
      },
      {
        time: "11:15",
        title: "CX564 飛往 KIX",
        icon: <Icon component={Plane} />,
        note: "14:55 抵達關西 T1",
      },
      {
        time: "16:00",
        title: "南海電鐵 Rapi:t",
        icon: <Icon component={Train} />,
        note: "點擊查看詳細動線指引",
        options: [
          {
            name: "時刻表查詢 & 官網",
            desc: "點擊前往南海電鐵官網查看最新班次",
            link: "https://www.howto-osaka.com/tc/access-timetable/",
            tag: "時刻表",
          },
          {
            name: "Step 1. 出關後怎麼走",
            desc: "出入境後 👉 跟著「鉄道 (Railways)」指標，搭手扶梯上 2 樓走過空橋抵達車站。",
            tag: "動線",
            image: "/images/nankai_step1.jpg",
          },
          {
            name: "Step 2. 購票與換票",
            desc: "前往紅色櫃檯 (Nankai)，出示憑證換取 Rapi:t 實體票。",
            tag: "換票",
            image: "/images/nankai_step2.jpg",
          },
          {
            name: "Step 3. 快速辨識",
            desc: "JR 是藍色，南海是紅色。看到紅色「Nankai」改札口跟著走即可！",
            tag: "秘訣",
            image: "/images/nankai_step3.jpg",
          },
        ],
      },
      {
        time: "17:00",
        title: "東橫INN 大阪難波 Check-in",
        icon: <Icon component={Hotel} />,
        map: "https://maps.app.goo.gl/k1rBmfRHyphyd5vz8",
        note: "寄放行李",
      },
      {
        time: "18:00",
        title: "梅田逛街",
        icon: <Icon component={ShoppingBag} />,
        note: "點擊查看逛街地圖",
        options: [
          {
            name: "BABYMONSTER 快閃店",
            desc: "⏰ 11:00–21:00 (20:30最後入場)",
            map: "https://maps.app.goo.gl/9sovyaqExg4HtLjh6",
            tag: "必去",
            visibleTo: ["Cindy", "Candy", "Amy"], // ✅ 只有這三人看得到
            link: "https://docs.google.com/spreadsheets/d/10d0BN55WkCvuhbPsGizeJTH-D3K8LCsb8Nb43WCOTpw/edit?gid=1239499949#gid=1239499949",
          },
          {
            name: "大創",
            desc: "⏰ 09:00–22:00",
            map: "https://maps.app.goo.gl/w13JDSArUdhi9bJ97",
            tag: "必去",
          },
          {
            name: "Bottega Veneta (葆蝶家) 梅田阪急店",
            desc: "👜 營業時間：10:00-20:00｜位於阪急百貨梅田總店",
            map: "https://maps.app.goo.gl/Q2u5o3w2YPihdrkXA",

            tag: "精品購物",
          },
          {
            name: "星巴克 LINKS 梅田 2F（必喝推薦：焙茶 & 經典茶拿鐵 (特調)）",
            desc: "📝 點餐攻略：少糖 (Light Syrup)、少冰 (Light Ice)、加奶泡 (Add Mousse Foam +55円)｜口感：白巧克力風味糖漿，少糖剛好不甜膩！",
            map: "https://maps.app.goo.gl/tQhNPYv95PZaoKXY8",
            image: "/food/hojicha-special.jpg",
            tag: "星巴克特調",
          },
          {
            name: "grenier Umeda",
            desc: "推薦：烤布蕾千層酥",
            image: "/food/GrenierUmedaMenu.jpg",
            map: "https://maps.app.goo.gl/vKUSDbwUqrkzKZyZ7",
            tag: "甜點",
          },
        ],
      },
      {
        time: "Dinner",
        title: "梅田晚餐選擇",
        options: [
          {
            name: "千代松 勝蓋飯",
            desc: "超厚切特大豬排丼！",
            map: "https://maps.app.goo.gl/TEcXE8DheFqA5Ffw8",
            image: "/food/katsudon.jpg",
            tag: "排隊美食",
          },
          {
            name: "Kishimen Amano 烏龍麵",
            desc: "老牌烏龍麵，湯頭清爽，適合不想吃太油的人。",
            map: "https://maps.app.goo.gl/vDZA4MVKudmmKHCR9",
            image: "/food/udon.jpg",
            tag: "在地推薦",
          },
        ],
        note: "點擊查看詳細選擇",
      },
      {
        time: "20:00",
        title: "梅田扭蛋",
        icon: <Icon component={Gamepad2} />,
        note: "點擊查看扭蛋店清單",
        options: [
          {
            name: "C-pla 扭蛋店",
            desc: "10:00–23:00",
            map: "https://maps.app.goo.gl/SCvhXG2k1LsCTK9a6",
          },
          {
            name: "扭蛋之森 梅田茶屋町店",
            desc: "11:00–21:00",
            map: "https://maps.app.goo.gl/SSaibtxC6eyzBqza9",
          },
          {
            name: "Bandai Namco Cross Store",
            desc: "11:00–21:00",
            map: "https://maps.app.goo.gl/i2xSeJWqpD5Yhckn7",
          },
        ],
      },
      {
        time: "Late",
        title: "超市 & 宵夜採買",
        icon: <Icon component={Store} />,
        note: "Lawson 取票 / 買牛奶布丁",
        options: [
          {
            name: "Lawson 取票 (5張 S席)",
            desc: "金額：¥103,200｜請出示 QR Code",
            map: "https://maps.app.goo.gl/dAzVMb8p6hVNQJCm9",
            image: "/tickets/lawson_5.jpg",
            tag: "取票 1",
          },
          {
            name: "Lawson 取票 (3張 S席)",
            desc: "金額：¥61,920｜請出示 QR Code",
            map: "https://maps.app.goo.gl/dAzVMb8p6hVNQJCm9",
            image: "/tickets/lawson_3.jpg",
            tag: "取票 2",
          },
          {
            name: "7-Eleven",
            desc: "採買",
            map: "https://maps.app.goo.gl/S8Vx5EwP532dbSC59",
            products: [
              {
                name: "襪子",
                image: "/images/sock.jpg",
              },
            ],
          },
          {
            name: "唐吉訶德 道頓堀御堂筋店",
            desc: "補貨、買伴手禮",
            map: "https://maps.app.goo.gl/NA89JYR4vUqX6YiW8",
            hasCoupon: true,
            products: [
              {
                name: "涼糖",
                image: "/images/candy_cool.jpg",
                note: "⚠️ 檢查效期",
              },
              { name: "乳液", image: "/images/lotion.jpg" },
              {
                name: "Glico 百力滋 PRETZ 日式醬油扇貝口味",
                image: "/food/cookie.jpg",
              },
            ],
          },
          {
            name: "LIFE中央廣場 難波店",
            desc: "09:00–00:00",
            map: "https://maps.app.goo.gl/ofAkxz6uHrjeosek6",
          },
          {
            name: "AEON FOOD STYLE",
            desc: "24小時營業，隨時可去",
            map: "https://maps.app.goo.gl/r6RnCQKu9ZwSkasU6",
          },
          {
            name: "宵夜清單",
            desc: "牛奶、布丁 (帶回飯店冰)",
            tag: "必買",
            products: [
              { name: "明治好喝牛奶", image: "/food/meiji.jpg" },
              { name: "北海道十勝", image: "/food/tokachi.jpg" },
              { name: "OHAYO布丁", image: "/food/pudding.jpg" },
            ],
          },
        ],
      },
    ],
  },
  {
    day: 2,
    date: "1/22 (四)",
    title: "神社巡禮 & Lady Gaga 演唱會",
    highlight: true,
    events: [
      {
        time: "08:00",
        title: "Yawaragi 早餐 (彈性)",
        desc: "05:00–08:00",
        icon: <Icon component={Coffee} />,
        map: "https://maps.app.goo.gl/ENjzYHCxVu4PJJbh7",
        note: "玉子燒推薦 (只收現金)，早餐 Set ¥1100（需另外點一杯飲料）",
      },
      // 修正：這裡改用 Landmark
      {
        time: "10:00",
        title: "難波八阪神社",
        icon: <Icon component={Landmark} />,
        map: "https://maps.app.goo.gl/isPLjrn8eSCSrdsb7",
        note: "巨大獅子頭 / 求籤 ¥500",
      },
      {
        time: "Lunch",
        title: "道頓堀午餐選擇",
        icon: <Icon component={Utensils} />,
        note: "點擊查看詳細菜單",
        options: [
          {
            name: "Shabucho (しゃぶ長)",
            desc: "壽喜燒推薦|CP 值最高的用餐時段是午餐商業套餐",
            map: "https://maps.app.goo.gl/uTeya6hcJuNdKyAm7?g_st=ic",
            image: "/food/shabucho.jpg", // 請自行準備圖片
            tag: "壽喜燒",
          },
          {
            name: "道頓堀今井 本店",
            desc: "11:30-21:00 | 烏龍麵、蕎麥麵老店",
            map: "https://maps.app.goo.gl/uTeya6hcJuNdKyAm7?g_st=ic", // 請替換真實連結
            image: "/food/imai.jpg",
            tag: "老店",
          },
        ],
      },
      {
        time: "13:00",
        title: "心齋橋逛街 & 採買",
        icon: <Icon component={ShoppingBag} />,
        note: "UNIQLO、麵包、甜點",
        options: [
          {
            name: "UNIQLO 心齋橋店",
            desc: "⏰ 11:00–21:00",
            map: "https://maps.app.goo.gl/ZEnj4VSvLvUSQnMi7",
            tag: "逛街",
            products: [
              {
                name: "吊牌確認 (價格/型號)",
                image: "/shopping/uniqlo_price.jpg", // ✅ 記得放圖片
                note: "Hybrid 羽絨大衣 Size: L / 09 Black",
              },
              {
                name: "試穿參考",
                image: "/shopping/uniqlo_tryon.jpg", // ✅ 記得放圖片
                note: "實際穿著效果",
              },
            ],
          },
          {
            name: "GU 心齋橋店",
            desc: "⏰ 11:00–21:00",
            map: "https://maps.app.goo.gl/SDNp26m1whaxJ9tP9",
            tag: "逛街",
          },
          {
            name: "MUJIcom Crysta長堀店",
            desc: "⏰ 11:00–21:00",
            map: "https://maps.app.goo.gl/ZpCC5htg8oZLiUth7",
            visibleTo: ["Cindy", "Candy", "Amy"],
            tag: "逛街",
            products: [
              {
                name: "吊牌確認 (價格/型號)",
                image: "/shopping/muji_price.jpg",
                note: "中腰內褲 Size: L / 09 Black",
              },
            ],
          },
          {
            name: "Cookhouse Namba Walk",
            desc: "🍞 必買：大理石麵包 (當明天 USJ 早餐)",
            map: "https://maps.app.goo.gl/ZEnj4VSvLvUSQnMi7",
            tag: "重要",
          },
          {
            name: "PANAME Crêpes de Paris",
            desc: "可麗餅推薦",
            map: "https://maps.app.goo.gl/ZEnj4VSvLvUSQnMi7",
            tag: "甜點",
          },
        ],
      },
      {
        time: "Teatime",
        title: "下午茶 & 咖啡",
        icon: <Icon component={Coffee} />,
        note: "烤團子、抹茶、咖啡",
        options: [
          {
            name: "喜八洲總本舖 (高島屋店)",
            desc: "🍡 烤團子 (みたらし団子)",
            map: "https://maps.app.goo.gl/GBwPAQyaNGY7F4R46",
            image: "/food/kiyasu.jpg",
            tag: "必吃",
          },
          {
            name: "OBRA 抹茶拿鐵專門店",
            // ✅ 更新描述，加入詳細介紹，使用 \n 換行讓版面更清楚
            desc: "⏰ 10:00–18:00｜三種濃郁度宇治抹茶可選！\n🍵「奧綠」：100%最高品質宇治抹茶，適合喝純茶。\n🍵「和乃」：偏苦帶澀，最適合做成抹茶拿鐵。",
            map: "https://maps.app.goo.gl/GBwPAQyaNGY7F4R46",
            // ✅ 加入主圖 (Demo照)
            image: "/food/obra_drink.jpg",
            tag: "極致抹茶",

            products: [
              {
                name: "詳細菜單 (Menu)",
                image: "/food/obra_menu1.jpg",
                note: "不同茶種與濃度介紹",
              },
            ],
          },
          {
            name: "星巴克 難波 SkyO 3F",
            desc: "休息充電",
            map: "https://maps.app.goo.gl/GBwPAQyaNGY7F4R46",
          },
          {
            name: "Barista Map Coffee Roasters",
            desc: "專業手沖咖啡",
            map: "https://maps.app.goo.gl/GBwPAQyaNGY7F4R46",
          },
        ],
      },
      {
        time: "17:00",
        title: "京瓷巨蛋入場",
        icon: <Icon component={Music} />,
        map: "https://maps.app.goo.gl/GYRuSpbRPr6yxswe9",
        note: "記得帶票(需面交) & 行動電源!",
      },
      {
        time: "19:00",
        title: "LADY GAGA CONCERT",
        icon: <Icon component={Star} />,
        isConcert: true,
        note: "Enjoy the show! (點擊開歌詞)",
      },
      {
        time: "Late",
        title: "宵夜：串燒 BATTEN YOKATO",
        icon: <Icon component={Utensils} />,
        map: "https://maps.app.goo.gl/LHnPsTXh1FucNF5F7",
      },
    ],
  },
  {
    day: 3,
    date: "1/23 (五)",
    title: "USJ 環球影城 (Express 7)",
    events: [
      {
        time: "05:03",
        title: "早起出發!",
        icon: <Icon component={Train} />,
        note: "難波→西九條(轉JR)→環球城",
      },
      {
        time: "TICKET",
        title: "USJ 電子門票 & 餐券",
        icon: <Icon component={Ticket} />,
        note: "點擊開啟入場 QR Code",
        visibleTo: ["Cindy", "Candy", "Amy", "Emily"],
        options: [
          {
            name: "入場門票 QR Code (1)",
            image: "/tickets/usj_ticket_1.jpg",
            tag: "掃碼入場",
          },
          {
            name: "入場門票 QR Code (2)",
            image: "/tickets/usj_ticket_2.jpg",
            tag: "掃碼入場",
          },
          {
            name: "入場門票 QR Code (3)",
            image: "/tickets/usj_ticket_3.jpg",
            tag: "掃碼入場",
          },
          {
            name: "餐券使用說明 (Demo)",
            image: "/tickets/usj_meal_demo.jpg",
            desc: "這是範例，請下滑使用正式餐券",
            tag: "說明",
          },
          {
            id: "meal_coupon_1", // ✅ 加上 ID 才能追蹤狀態
            name: "¥1000 餐飲兌換券 #1",
            desc: "結帳時出示 QR Code",
            image: "/tickets/usj_meal_1.jpg",
            canMarkUsed: true, // ✅ 標記為可核銷
            tag: "餐券",
          },
          {
            id: "meal_coupon_2",
            name: "¥1000 餐飲兌換券 #2",
            desc: "結帳時出示 QR Code",
            image: "/tickets/usj_meal_2.jpg",
            canMarkUsed: true,
            tag: "餐券",
          },
          {
            id: "meal_coupon_3",
            name: "¥1000 餐飲兌換券 #3",
            desc: "結帳時出示 QR Code",
            image: "/tickets/usj_meal_3.jpg",
            canMarkUsed: true,
            tag: "餐券",
          },
        ],
      },
      {
        time: "Checklist",
        title: "必玩設施清單",
        icon: <Icon component={Star} />,
        note: "點擊查看詳細",
        options: [
          {
            name: "哈利波特禁忌之旅",
            desc: "雖然玩過但還是經典，必玩！",
            tag: "必玩",
          },
          {
            name: "飛天翼龍",
            desc: "超刺激懸掛式雲霄飛車，面部朝下！",
            tag: "刺激",
          },
          {
            name: "瑪利歐賽車：庫巴的挑戰書",
            desc: "AR 賽車體驗，記得拿帽子！",
            tag: "必玩",
          },
          {
            name: "小小兵瘋狂乘車遊",
            desc: "3D 模擬設施，容易暈車請斟酌。",
            tag: "不太推", // 標記為不太推
          },
        ],
      },
      {
        time: "Show",
        title: "必看表演 & 遊行時間",
        icon: <Icon component={Camera} />,
        note: "水世界、小小兵迎賓",
        options: [
          {
            name: "水世界 WaterWorld",
            desc: "場次：12:15、14:30、16:45",
            note: "⚠️ 攻略：往左邊坐，不要太前面會有水，提早 30 分鐘入場",
            tag: "必看",
          },
          {
            name: "小小兵大壞蛋大會迎賓",
            desc: "場次：10:15、11:30、14:00、15:15",
            tag: "拍照",
          },
        ],
      },
      {
        time: "07:30",
        title: "衝刺：咚奇剛瘋狂礦車",
        icon: <Icon component={Zap} />,
        note: "🔥 首要目標！新園區！",
      },
      {
        time: "AM",
        title: "超級任天堂世界",
        icon: <Icon component={Gamepad2} />,
        note: "庫巴挑戰書 / 金幣收集",
      },
      {
        time: "11:00",
        title: "哈利波特魔法世界",
        icon: <Icon component={Wand2} />,
        note: "禁忌之旅 (記得吃暈車藥)",
      },
      {
        time: "Dinner",
        title: "一蘭拉麵 難波御堂筋店",
        icon: <Icon component={Utensils} />,
        note: "點擊查看菜單與實際照片",
        options: [
          {
            name: "100% 不使用豚骨拉麵",
            desc: "全日本限定！雞湯底 + 牛五花叉燒｜大阪限定「方型碗」",
            map: "https://maps.app.goo.gl/AeJQhY7HqtqezvxDA",
            tag: "No Pork",
            products: [
              {
                name: "食券機 Menu",
                image: "/food/ichiran_menu.jpg",
                note: "先在門口買票，可選濃淡/蒜/麵硬度，一蘭拉麵5選 ¥1720",
              },
              {
                name: "客製化的點餐用紙",
                image: "/food/order_sheet.jpg",
                note: "依照自己的喜好劃上味道的濃淡、麵條的硬度、要不要蒜、蔥、牛肉、秘製醬汁等",
              },
              {
                name: "實際拉麵 (牛五花)",
                image: "/food/ichiran_ramen.jpg",
                note: "重箱方碗，湯頭清爽但濃郁",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    day: 4,
    date: "1/24 (六)",
    title: "天神橋筋商店街 & 心齋橋",
    events: [
      {
        time: "AM",
        title: "天神橋筋商店街",
        icon: <Icon component={Footprints} />,
        map: "https://maps.app.goo.gl/uaqfn1RWckW86pFbA.",
        note: "日本最長商店街 / 邊走邊吃",
      },
      {
        time: "Lunch",
        title: "天神橋筋美食選擇", // 改標題
        icon: <Icon component={Utensils} />,
        note: "點擊查看詳細：大阪燒、燒肉",
        options: [
          {
            name: "お好み焼 (大阪燒) 千草",
            desc: "⏰ 11:00-21:00 (週二休)｜推薦必吃 No.1 千草燒 (1,100円)",
            map: "https://maps.app.goo.gl/9sovyaqExg4HtLjh64",
            image: "/food/chigusa.jpg",
            tag: "排隊名店",
          },
          {
            name: "肉の天満屋 神楽亭",
            desc: "⏰ 11:30-15:00、17:00-22:30｜推薦：烤牛筋",
            map: "https://maps.app.goo.gl/9sovyaqExg4HtLjh65",
            image: "/food/kaguratei.jpg",
            tag: "燒肉/烤牛筋",
          },
        ],
      },
      {
        time: "Shopping",
        title: "超市 / 藥妝 / 伴手禮",
        icon: <Icon component={ShoppingBag} />,
        note: "點擊查看店家與優惠券",
        options: [
          {
            name: "Sundrug 天満駅前店",
            desc: "⏰ 10:00-22:00｜記得用優惠券！",
            map: "https://maps.app.goo.gl/9sovyaqExg4HtLjh66",
            image: "/food/sundrug.jpg",
            hasCoupon: true,
            tag: "藥妝",
          },
          {
            name: "玉出超市 天神橋店",
            desc: "⏰ 24小時營業｜大阪獨有，日本第一便宜超市",
            map: "https://maps.app.goo.gl/9sovyaqExg4HtLjh67",
            image: "/food/tamade.jpg",
            tag: "便宜必逛",
          },
          {
            name: "まるしげ (呼吸巧克力)",
            desc: "⏰ 10:00-19:00｜大阪名產，適合當伴手禮",
            map: "https://maps.app.goo.gl/9sovyaqExg4HtLjh68",
            image: "/food/chocolate.jpg",
            tag: "伴手禮",
          },
          {
            name: "SUGI藥局 扇町店/南森町店",
            desc: "⏰ 09:00-22:00｜選擇多樣的連鎖藥妝",
            map: "https://maps.app.goo.gl/9sovyaqExg4HtLjh69",
            hasCoupon: true, // SUGI 也有優惠券
          },
          {
            name: "C-pla 扭蛋店",
            desc: "Capsule Toy Shop",
            map: "https://maps.app.goo.gl/TEcXE8DheFqA5Ffw80",
          },
        ],
      },
      {
        time: "Optional",
        title: "大阪天滿宮",
        icon: <Icon component={Landmark} />,
        map: "https://maps.app.goo.gl/7UghVsc5BVQU5x478",
        note: "求學業/摸神牛",
      },
      {
        time: "Teatime",
        title: "下午茶點心",
        icon: <Icon component={IceCream} />,
        note: "點擊查看甜點清單",
        options: [
          {
            name: "MooKEN 大阪小泡芙",
            desc: "口感酥脆，內餡飽滿",
            map: "https://maps.app.goo.gl/TEcXE8DheFqA5Ffw81",
          },
          {
            name: "喜八洲總本舖 (高島屋店)",
            desc: "烤團子推薦 (みたらし団子)",
            map: "https://maps.app.goo.gl/TEcXE8DheFqA5Ffw82",
            tag: "經典日式",
          },
        ],
      },
      {
        time: "16:00",
        title: "心齋橋 PARCO",
        desc: "🛍️ 必買清單：\n1. PARCO 2F (The North Face 紫標)：黑色小包\n2. Uniqlo：極暖發熱衣 (尺寸: XL)",
        map: "https://maps.app.goo.gl/yvtaNkDEa8CNsydE7",
        note: "點擊查看必買清單圖片", // ✅ 修改 Note 提示
        icon: <Icon component={ShoppingBag} />,
        options: [
          {
            name: "The North Face Purple Label (紫標)",
            desc: "PARCO 2F｜必買清單：黑色小包",
            map: "https://maps.app.goo.gl/yvtaNkDEa8CNsydE7",
            image: "/shopping/tnf-bag.jpg",
            tag: "必買",
          },
        ],
      },
      {
        time: "Evening",
        title: "跑跑人拍照 & 道頓堀河岸",
        icon: <Icon component={Camera} />,
        note: "大阪必拍地標！精選三個最佳拍攝位置：",
        // 新增 spots 欄位來儲存詳細地點
        options: [
          {
            name: "戎橋 (Ebisubashi)",
            tag: "最經典",
            desc: "就在跑跑人看板正下方，可以近距離合影，人潮最多。",
            map: "https://www.google.com/maps/search/?api=1&query=Ebisubashi+Bridge+Osaka",
          },
          {
            name: "道頓堀河岸步道",
            tag: "全景",
            desc: "越過戎橋往對岸走，視野開闊，能拍到完整看板與河景。",
            map: "https://www.google.com/maps/search/?api=1&query=Tombori+River+Walk",
          },
          {
            name: "nanohana 戎橋店",
            tag: "隱藏版",
            desc: "看板正對面的藥妝店，利用借位可拍出乾淨無路人背景 (需配合營業時間)。",
            image: "/images/nanohana.jpg",
            map: "https://www.google.com/maps/search/?api=1&query=nanohana+Ebisubashi+Osaka",
          },
        ],
      },
      {
        time: "20:30",
        title: "行李打包 & 宵夜",
        icon: <Icon component={Gift} />,
        note: "最後整理",
      },
    ],
  },
  {
    day: 5,
    date: "1/25 (日)",
    title: "回程日 & 最後採買",
    events: [
      { time: "10:00", title: "飯店退房", icon: <Icon component={Hotel} /> },
      {
        time: "Brunch",
        title: "Tonkatsu New Babe 炸豬排",
        icon: <Icon component={Utensils} />,
        map: "https://maps.app.goo.gl/RzcqdqYqi3c27e6D6",
        note: "最後的美食",
      },
      {
        time: "13:30",
        title: "前往機場 (南海電鐵)",
        icon: <Icon component={Train} />,
        note: "點擊查看時刻表 (13:35 / 14:05 都有車)", // ✅ 提示改得更清楚
        options: [
          {
            name: "難波 → 關西機場 時刻表",
            desc: "推薦搭乘：\n13:35 (特急 Rapi:t β 47號)\n14:05 (特急 Rapi:t α 7號)\n⚠️ 務必提早 10 分鐘抵達月台",
            image: "/images/nankai_timetable_return.jpg",
            link: "https://www.howto-osaka.com/tc/access-timetable/",
            tag: "時刻表",
          },
        ],
      },
      {
        time: "16:15",
        title: "CX565 飛往 TPE",
        icon: <Icon component={Plane} />,
        note: "18:30 抵達台灣，回家囉！",
      },
    ],
  },
];

export const users = ["Emily", "Candy", "Max", "Amy", "Cindy"];
